import request from '@/utils/request'

export function listContractRelatedMatters(data) {
  return request({ url: '/crmContract/relatedMatters/list', method: 'post', data })
}
